import { baseApi } from "@/shared/api";
import { fileResponseHandler, type FileResponse } from "@/shared/utils";

export const applicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    previewResignationApplication: builder.mutation<FileResponse, number>({
      query: (id) => ({
        url: `/api/hr/resignation-letters/${id}/preview/`,
        method: "GET",
        credentials: "include",
        responseHandler: fileResponseHandler,
      }),
    }),
  }),
});

export const {
  usePreviewResignationApplicationMutation,
} = applicationApi;
